'use client'

import { EmbeddedCheckout, EmbeddedCheckoutProvider } from '@stripe/react-stripe-js'
import { getStripeForAccount } from '@/lib/stripe-client'
import { ArrowLeft } from 'lucide-react'
import { useMemo } from 'react'
import { Language } from '@/lib/interfaces/interfaces'

interface Props {
  clientSecret: string
  connectId: string
  onClose: () => void
  language: Language
}

const backLabels: Partial<Record<Language, string>> = {
  es: 'Volver',
  en: 'Back',
  fr: 'Retour',
  ca: 'Tornar',
  de: 'Zurück'
}

const DeliveryEmbeddedCheckout = ({ clientSecret, connectId, onClose, language }: Props) => {
  const stripePromise = useMemo(
    () => typeof window !== 'undefined' ? getStripeForAccount(connectId) : null,
    [connectId]
  )

  const backLabel = backLabels[language] ?? 'Back'

  return (
    <div className='embedded-checkout'>
      <button className='embedded-checkout__back' onClick={onClose} type='button'>
        <ArrowLeft size={16} />
        <span>{backLabel}</span>
      </button>
      <div className='embedded-checkout__frame'>
        <EmbeddedCheckoutProvider stripe={stripePromise} options={{ clientSecret }}>
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      </div>
    </div>
  )
}

export default DeliveryEmbeddedCheckout
